import axios from '../../axios'
import { takeLatest, call, put } from 'redux-saga/effects'
import { createAction, Action } from 'redux-actions'

// Saga action strings
export const REGISTER = 'saga/Registration/REGISTER'
export const REGISTER_SUCCESS = 'saga/Registration/REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'saga/Registration/REGISTER_FAILURE'
export const REGISTER_FAILURE_EMAIL_EXISTS = 'saga/Registration/REGISTER_FAILURE_EMAIL_EXISTS'
export const actions = {
  REGISTER,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  REGISTER_FAILURE_EMAIL_EXISTS
}
type RegistrationSagaActionCreators = {
  register: () => Action<any>,
  registerSuccess: number => Action<any>,
  registerFailure: object => Action<any>,
  registerFailureEmailExists: object => Action<any>
}

export const actionCreators: RegistrationSagaActionCreators = {
  register: createAction(REGISTER),
  registerSuccess: createAction(REGISTER_SUCCESS),
  registerFailure: createAction(REGISTER_FAILURE),
  registerFailureEmailExists: createAction(REGISTER_FAILURE_EMAIL_EXISTS)
}

export default function * watchRegistration () {
  yield takeLatest(REGISTER, getRegistration)
}

export function * getRegistration (action) {
  try {
    const register = yield call(axios.post, 'auth/register', {
      email: action.payload.email,
      password: action.payload.password,
      firstName: action.payload.firstName,
      lastName: action.payload.lastName || '',
      birthDate: action.payload.birthDate || '',
      current_school_id: action.payload.current_school_id,
      tos: action.payload.acceptTos,
      captchaResponse: action.payload.captchaResponse,
      participationDisclosure: false,
      role: 'student'
    })
    yield put(actionCreators.registerSuccess(register.data))
  } catch (error) {
    if (error.response) {
      let errorString = JSON.stringify(error.response.data.errors)
      if (errorString.includes('An account with that email already exists.')) {
        yield put(actionCreators.registerFailureEmailExists(errorString))
      } else {
        yield put(actionCreators.registerFailure(error.response.data.errors))
      }
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      yield put(actionCreators.registerFailure(error.request))
    } else {
      // Something happened in setting up the request that triggered an Error
      yield put(actionCreators.registerFailure(error.message))
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/registration/registrationSaga.js